import { CrisisAlertLine } from 'Components/lines/crisis-alert-line/CrisisAlertLine';
export default CrisisAlertLine;
